import { render } from "./event_detail.vue?vue&type=template&id=5e140443&scoped=true"
import script from "./event_detail.vue?vue&type=script&lang=js"
export * from "./event_detail.vue?vue&type=script&lang=js"

import "./event_detail.vue?vue&type=style&index=0&id=5e140443&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e140443"]])

export default __exports__